import React from 'react';
import { Box, Container } from '@mui/material';

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        background: (theme) => theme.palette.mode === 'dark' 
          ? `linear-gradient(135deg, ${theme.palette.background.default} 0%, #2A2F35 50%, ${theme.palette.background.default} 100%)`
          : `linear-gradient(135deg, ${theme.palette.background.default} 0%, #E8F2FF 50%, ${theme.palette.background.default} 100%)`,
        position: 'relative',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: (theme) => theme.palette.mode === 'dark'
            ? `radial-gradient(circle at 20% 80%, rgba(138, 155, 168, 0.08) 0%, transparent 60%),
               radial-gradient(circle at 80% 20%, rgba(166, 153, 144, 0.08) 0%, transparent 60%),
               radial-gradient(circle at 40% 40%, rgba(123, 154, 174, 0.06) 0%, transparent 60%)`
            : `radial-gradient(circle at 20% 80%, rgba(105, 122, 137, 0.12) 0%, transparent 60%),
               radial-gradient(circle at 80% 20%, rgba(139, 126, 116, 0.12) 0%, transparent 60%),
               radial-gradient(circle at 40% 40%, rgba(120, 159, 138, 0.08) 0%, transparent 60%)`,
          pointerEvents: 'none',
        },
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 3,
          position: 'relative',
          zIndex: 1,
        }}
      >
        {children}
      </Container>
    </Box>
  );
};

export default PublicLayout;